import React, { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory } from "react-router";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function AsignarPlantillas() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    
    // Datos
    const [usuarios, setUsuarios] = useState([]);
    const [plantillas, setPlantillas] = useState([]);
    const [asignaciones, setAsignaciones] = useState([]);
    
    // Selección
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState('');
    const [plantillasSeleccionadas, setPlantillasSeleccionadas] = useState([]);
    
    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        // Validación de permisos híbrida
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(p => p.slug === 'administrarPlantillas');
        } else if (userdata.up && userdata.up.includes('administrarPlantillas')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }
        
        setHasPermission(true);
        cargarDatos(userdata);
    }, []);
    
    const cargarDatos = (userdata) => {
        setLoading(true);
        
        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => console.error(error));
        
        // Cargar usuarios
        axios.get('/users?uid=' + userdata.user_id)
            .then(response => {
                setUsuarios(response.data);
            })
            .catch(error => console.error(error));
        
        // Cargar plantillas
        axios.get('/plantillas-historia-clinica')
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => console.error(error));
        
        // Cargar asignaciones
        axios.get('/usuario-plantillas')
            .then(response => {
                setAsignaciones(response.data);
                setLoading(false);
                setLoggedIn(true);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
                setLoggedIn(true);
            });
    };
    
    // Cargar plantillas asignadas al usuario seleccionado (IDs normalizados para coincidir con plantilla.id del listado)
    useEffect(() => {
        if (usuarioSeleccionado) {
            const plantillasDelUsuario = asignaciones
                .filter(a => String(a.user_id) === String(usuarioSeleccionado))
                .map(a => Number(a.plantilla_id));
            setPlantillasSeleccionadas(plantillasDelUsuario);
        } else {
            setPlantillasSeleccionadas([]);
        }
    }, [usuarioSeleccionado, asignaciones]);
    
    // Toggle plantilla
    const togglePlantilla = (plantillaId) => {
        if (plantillasSeleccionadas.includes(plantillaId)) {
            setPlantillasSeleccionadas(plantillasSeleccionadas.filter(id => id !== plantillaId));
        } else {
            setPlantillasSeleccionadas([...plantillasSeleccionadas, plantillaId]);
        }
    };
    
    // Guardar asignaciones (sincroniza con el servidor: quita las desmarcadas y agrega las nuevas)
    const asignarPlantillas = () => {
        if (!usuarioSeleccionado) {
            alert('Por favor seleccione un usuario');
            return;
        }

        if (plantillasSeleccionadas.length === 0) {
            if (!window.confirm('¿Desea quitar todas las plantillas asignadas a este usuario?')) {
                return;
            }
        }

        setLoading(true);

        const data = {
            user_id: parseInt(usuarioSeleccionado, 10),
            plantilla_ids: plantillasSeleccionadas.map(id => Number(id)),
        };

        axios.post('/usuario-plantillas/asignar-multiples', data)
            .then(response => {
                alert(response.data?.message || 'Asignaciones guardadas correctamente');
                
                // Recargar asignaciones
                axios.get('/usuario-plantillas')
                    .then(response => {
                        setAsignaciones(response.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error(error);
                        setLoading(false);
                    });
            })
            .catch(error => {
                console.error(error);
                alert('Error al asignar plantillas: ' + (error.response?.data?.message || 'Error desconocido'));
                setLoading(false);
            });
    };
    
    // Desasignar plantilla individual
    const desasignarPlantilla = (asignacionId, plantillaNombre) => {
        if (!window.confirm(`¿Está seguro de desasignar la plantilla "${plantillaNombre}"?`)) {
            return;
        }
        
        setLoading(true);
        
        axios.delete(`/usuario-plantillas/${asignacionId}`)
            .then(response => {
                alert('Plantilla desasignada exitosamente');
                
                // Recargar asignaciones
                axios.get('/usuario-plantillas')
                    .then(response => {
                        setAsignaciones(response.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error(error);
                        setLoading(false);
                    });
            })
            .catch(error => {
                console.error(error);
                alert('Error al desasignar plantilla: ' + (error.response?.data?.message || 'Error desconocido'));
                setLoading(false);
            });
    };
    
    // Obtener nombre de usuario
    const getNombreUsuario = (userId) => {
        const usuario = usuarios.find(u => u.id == userId);
        return usuario ? `${usuario.name} ${usuario.lastname}` : 'Usuario desconocido';
    };
    
    // Obtener nombre de plantilla
    const getNombrePlantilla = (plantillaId) => {
        const plantilla = plantillas.find(p => p.id == plantillaId);
        return plantilla ? plantilla.nombre : 'Plantilla desconocida';
    };
    
    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;
    
    return (
        <div className="hold-transition sidebar-mini">
            <div className="wrapper">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>
                                        <i className="fas fa-users"></i> Asignar Plantillas a Usuarios
                                    </h1>
                                </div>
                                <div className="col-sm-6">
                                    <button 
                                        className="btn btn-secondary float-right"
                                        onClick={() => history.push('/plantillas-historia-clinica-json')}
                                    >
                                        <i className="fas fa-arrow-left"></i> Volver
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Panel de asignación */}
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header bg">
                                            <h3 className="card-title">Asignar Plantillas</h3>
                                        </div>
                                        <div className="card-body">
                                            {/* Selector de usuario */}
                                            <div className="form-group">
                                                <label>Seleccione un Usuario *</label>
                                                <select
                                                    className="form-control"
                                                    value={usuarioSeleccionado}
                                                    onChange={(e) => setUsuarioSeleccionado(e.target.value)}
                                                >
                                                    <option value="">-- Seleccione un usuario --</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>
                                                            {usuario.name} {usuario.lastname} ({usuario.email})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            {usuarioSeleccionado && (
                                                <>
                                                    <hr />
                                                    <h5>Plantillas Disponibles</h5>
                                                    <p className="text-muted">Seleccione las plantillas que desea asignar:</p>
                                                    
                                                    {plantillas.length === 0 && (
                                                        <div className="alert alert-info">
                                                            <i className="fas fa-info-circle"></i> No hay plantillas disponibles.
                                                        </div>
                                                    )}
                                                    
                                                    {plantillas.map(plantilla => (
                                                        <div key={plantilla.id} className="form-check mb-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`plantilla_${plantilla.id}`}
                                                                checked={plantillasSeleccionadas.includes(plantilla.id)}
                                                                onChange={() => togglePlantilla(plantilla.id)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`plantilla_${plantilla.id}`}>
                                                                <strong>{plantilla.nombre}</strong>
                                                                {plantilla.especialidad && (
                                                                    <span className="badge badge-info ml-2">{plantilla.especialidad}</span>
                                                                )}
                                                                {plantilla.descripcion && (
                                                                    <small className="d-block text-muted">{plantilla.descripcion}</small>
                                                                )}
                                                            </label>
                                                        </div>
                                                    ))}
                                                    
                                                    <hr />
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        onClick={asignarPlantillas}
                                                        disabled={loading}
                                                    >
                                                        {loading ? (
                                                            <>
                                                                <i className="fas fa-spinner fa-spin"></i> Guardando...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="fas fa-save"></i> Guardar asignaciones
                                                            </>
                                                        )}
                                                    </button>
                                                </>
                                            )}
                                            
                                            {!usuarioSeleccionado && (
                                                <div className="alert alert-secondary text-center">
                                                    <i className="fas fa-arrow-up"></i> Seleccione un usuario para comenzar
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Panel de asignaciones actuales */}
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-header bg">
                                            <h3 className="card-title">Asignaciones Actuales</h3>
                                        </div>
                                        <div className="card-body">
                                            {loading && (
                                                <div className="text-center">
                                                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                                                    <p>Cargando asignaciones...</p>
                                                </div>
                                            )}
                                            
                                            {!loading && asignaciones.length === 0 && (
                                                <div className="alert alert-info">
                                                    <i className="fas fa-info-circle"></i> No hay asignaciones registradas.
                                                </div>
                                            )}
                                            
                                            {!loading && asignaciones.length > 0 && (
                                                <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                    <table className="table table-sm table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Usuario</th>
                                                                <th>Plantilla</th>
                                                                <th width="80">Acción</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {asignaciones.map(asignacion => (
                                                                <tr key={asignacion.id}>
                                                                    <td>
                                                                        <small>{getNombreUsuario(asignacion.user_id)}</small>
                                                                    </td>
                                                                    <td>
                                                                        <small><strong>{getNombrePlantilla(asignacion.plantilla_id)}</strong></small>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={() => desasignarPlantilla(asignacion.id, getNombrePlantilla(asignacion.plantilla_id))}
                                                                            title="Desasignar"
                                                                        >
                                                                            <i className="fas fa-times"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                
                <Footer />
            </div>
        </div>
    );
}

export default AsignarPlantillas;
